import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import User from '@/pages/ticket/user/page';
import Pin from '@/pages/ticket/pin/page';
import Home from '@/pages/home/page';
import Vehicles from '@/pages/vehicles/page';
import Checkout from '@/pages/checkout/page';
import CheckoutCard from '@/pages/checkout/card/page';
import CheckoutPix from '@/pages/checkout/pix/page';
import CheckoutFinished from '@/pages/checkout/finished/page';
import Index from '@/pages/page';
import Details from '@/pages/details/page';
import UserInfo from '@/pages/checkout/user/page';
import Ticket from '@/pages/ticket/page';
import Faq from '@/pages/faq/page';
import Contact from '@/pages/faq/contact/page';

const App = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/ticket/user" element={<User />} />
      <Route path="/ticket/pin" element={<Pin />} />
      <Route path="/ticket" element={<Ticket />} />
      <Route path="/home" element={<Home />} />
      <Route path="/details/:id" element={<Details />} />
      <Route path="/vehicles" element={<Vehicles />} />
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/checkout/user/:id" element={<UserInfo />} />
      <Route path="/checkout/card" element={<CheckoutCard />} />
      <Route path="/checkout/pix" element={<CheckoutPix />} />
      <Route path="/checkout/finished" element={<CheckoutFinished />} />
      <Route path="/faq" element={<Faq />} />
      <Route path="/faq/contact" element={<Contact />} />
      <Route path="*" element={<Navigate to="/" replace/>} />
    </Routes>
  </Router>
);

export default App;
